import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'AdminUser',
    column_type: 'id',
    label_key_path: 'adminUser.id',
  },
  created_at: {
    model_name: 'AdminUser',
    column_type: 'datetime',
    label_key_path: 'adminUser.createdAt',
  },
  updated_at: {
    model_name: 'AdminUser',
    column_type: 'datetime',
    label_key_path: 'adminUser.updatedAt',
  },
  email: {
    model_name: 'AdminUser',
    column_type: 'string',
    label_key_path: 'adminUser.email',
  },
  name: {
    model_name: 'AdminUser',
    column_type: 'string',
    label_key_path: 'adminUser.name',
  },
  user: {
    model_name: 'AdminUser',
    column_type: 'belongs_to',
    label_key_path: 'adminUser.user',
    extra: {
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
      display_column: 'screen_name',
    },
  },
  user_id: {
    model_name: 'AdminUser',
    column_type: 'belongs_to',
    label_key_path: 'adminUser.user',
    extra: {
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
      display_column: 'screen_name',
    },
  },
  role: {
    model_name: 'AdminUser',
    column_type: 'string',
    label_key_path: 'adminUser.role',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
